import { render, staticRenderFns } from "./GiftType.vue?vue&type=template&id=39ea149a&scoped=true"
import script from "./GiftType.vue?vue&type=script&lang=js"
export * from "./GiftType.vue?vue&type=script&lang=js"
import style0 from "./GiftType.vue?vue&type=style&index=0&id=39ea149a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ea149a",
  null
  
)

export default component.exports